export { useHover } from "./useHover.web";
export { usePress } from "./usePress";
//# sourceMappingURL=index.web.js.map